<template>
  <el-row id="parameter" style="height: 100%;">
    <el-col :span="8" style="height:auto;background: white;width: 400px">
      <el-row type="flex" justify="center" style="height: 30px">
        <el-col :span="24">
          <el-col :span="24" style="text-align: end;">
            <span style="font-size: 19px;float: left;line-height: 30px;font-weight: bold">系统参数列表</span>
            <!--                        <el-button type="success" icon="el-icon-plus" style="background: #4EC880" size="small"-->
            <!--                                   @click="open3">新增参数</el-button>-->
          </el-col>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="height: calc(100% - 65px);">
        <el-col :span="24" style="height: auto;">
          <div style="padding: 10px; border: 1px solid #eee;border-bottom: none">
            <el-input class="sWei" placeholder="请输入系统参数名称进行快速检索" v-model="filterText"> </el-input>
          </div>
          <!--:class="$style.scrollbar"-->
          <el-scrollbar
            style="height:calc(100% - 40px);border: 1px solid #eee;
                    border-top:none"
          >
            <el-tree
              class="filter-tree"
              :data="data"
              @node-click="handleNodeClick"
              :props="defaultProps"
              node-key="define_id"
              :highlight-current="true"
              :filter-node-method="filterNode"
              :default-expanded-keys="[1000, 2000]"
              ref="tree"
            >
            </el-tree>
          </el-scrollbar>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="16" class="StoCen" style="height: auto">
      <el-row style="height: 20px;margin-top: 4px" type="flex" align="middle">
        <el-col :span="3" style="font-size: 17px;font-weight: bold">系统参数</el-col>
        <el-col :span="12" style="color: #409EFF;font-size: 17px;font-weight: bold">{{ schTitle1 }}</el-col>
        <el-col :span="3" :push="6">
          <!--                    <el-button type="text" :disabled="addUserDis" @click="upOpen" :style="{color:-->
          <!--                    updataActive?'#F8A929':'#eee',float:'right'}" style="font-size: 17px;" id="el-button">编辑-->
          <!--                    </el-button>-->
        </el-col>
      </el-row>
      <el-row class="xux"></el-row>
      <!--            <el-row v-for="(item,index) in valueArr" :key="index" style="font-size: 12px;height: auto">-->
      <!--            说明{{index+1}}:{{item}}-->
      <!--        </el-row>-->
      <el-row>
        <el-col :span="18">
          <el-form style="margin-left: 20px" ref="form" :model="tableData" label-width="80px" v-if="dec" :label-position="left" id="el-form">
            <el-form-item label="参数">
              <p v-text="tableData.parameter_id" style="margin: 0;color: #3b99f7;"></p>
            </el-form-item>
            <el-form-item label="名称">
              <p v-text="tableData.parameter_name" style="margin: 0"></p>
            </el-form-item>

            <el-form-item label="值" v-if="aaa()">
              <p v-text="tableData.parameter_value" style="margin: 0"></p>
              <!--                        <p style="margin: 0;line-height: 20px;color: #CDCFD0" v-if="inputType=='number'">{{defData.min_value}}&nbsp;~&nbsp;{{defData.max_value}}</p>-->
            </el-form-item>

            <el-form-item label="值" v-if="myonOff == 'TRUE-FALSE'">
              <el-switch style="margin: 0" v-model="tableData.parameter_value" active-color="#13ce66" :disabled="true"> </el-switch>
            </el-form-item>

            <el-form-item label="值" v-if="myonOff == 'DATE'">
              <!--                        <el-date-picker-->
              <!--                                v-model="tableData.parameter_value"-->
              <!--                                type="date"-->
              <!--                                value-format="yyyy-MM-dd"-->
              <!--                                placeholder="选择日期" style="width: 100%;"-->
              <!--                                :disabled="true">-->
              <!--                        </el-date-picker>-->
              <p v-text="tableData.parameter_value" style="margin: 0"></p>
              <!--                        <p style="margin: 0;line-height: 20px;color: #CDCFD0">{{defData.min_value}}&nbsp;~&nbsp;{{defData.max_value}}</p>-->
            </el-form-item>

            <el-form-item label="值" v-if="myonOff == 'LIST'">
              <p style="margin: 0" v-text="tableData.parameter_value"></p>
            </el-form-item>
            <!--                    <el-form-item label="有效">-->
            <!--                        <el-switch-->
            <!--                                style="margin: 0"-->
            <!--                                v-model="onOff"-->
            <!--                                active-color="#13ce66"-->
            <!--                                :disabled="true">-->
            <!--                        </el-switch>-->
            <!--                    </el-form-item>-->
          </el-form>
        </el-col>

        <!--                <el-col :span="16" style="font-size: 12px;color: #409EFF;margin-top:20px ">选项总数：{{tableData.length}}个</el-col>-->
        <el-col :span="6" style="text-align: end;float: right">
          <el-button type="warning" style="background: #FF9901;border: none" size="small" @click="dakaiTanKuang" :disabled="!updataActive">设定参数值</el-button>
        </el-col>
      </el-row>
    </el-col>

    <!--添加选项-->
    <el-dialog title="" :visible.sync="dialogFormVisible3">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加系统参数</span>
        <span>
          <el-button @click="addVerify(addDictionary)" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="abolish2()" size="small">取消</el-button>
        </span>
      </div>
      <el-row style="height: auto">
        <el-form :model="tableData" label-width="120px">
          <el-form-item label="参数">
            <el-input v-model="defData.parameter_id" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="名称">
            <el-input v-model="defData.parameter_name" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="值" v-if="aaa()">
            <el-input v-model="tableData.parameter_value" :type="inputType"></el-input>
            <p style="margin: 0;line-height: 20px" v-if="inputType == 'number'">{{ defData.min_value }}&nbsp;~&nbsp;{{ defData.max_value }}</p>
          </el-form-item>

          <el-form-item label="值" v-if="myonOff == 'TRUE-FALSE'">
            <el-switch v-model="tableData.parameter_value" active-color="#13ce66"> </el-switch>
          </el-form-item>

          <el-form-item label="值" v-if="myonOff == 'DATE'">
            <el-date-picker v-model="tableData.parameter_value" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;"> </el-date-picker>
            <p style="margin: 0;line-height: 20px">{{ defData.min_value }}&nbsp;~&nbsp;{{ defData.max_value }}</p>
          </el-form-item>

          <el-form-item label="值" v-if="myonOff == 'LIST'">
            <el-select v-model="tableData.parameter_value" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in options" :key="item.category" :label="item.name" :value="item.category"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
    <!--新增系统列表-->
    <el-dialog title="" :visible.sync="dialogFormVisible">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">添加系统参数</span>
        <span>
          <el-button @click="addlist(addParameters)" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="abolish()" size="small">取消</el-button>
        </span>
      </div>
      <el-row style="height: auto">
        <el-form :model="parameters" label-width="120px">
          <el-form-item label="参数">
            <el-input v-model="parameters.parameter_id"></el-input>
          </el-form-item>

          <el-form-item label="名称">
            <el-input v-model="parameters.parameter_name"></el-input>
          </el-form-item>

          <el-form-item label="参数类型">
            <el-select v-model="parameters.input_type" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最大值" v-if="parameters.input_type == 'NUMBER'">
            <el-input v-model="parameters.maxValue" type="number"></el-input>
          </el-form-item>
          <el-form-item label="最小值" v-if="parameters.input_type == 'NUMBER'">
            <el-input v-model="parameters.minValue" type="number"></el-input>
          </el-form-item>
          <el-form-item label="最大值" v-if="parameters.input_type == 'DATE'">
            <el-date-picker style="width: 100%" v-model="parameters.maxValue" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="最小值" v-if="parameters.input_type == 'DATE'">
            <el-date-picker style="width: 100%" v-model="parameters.minValue" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="有效">
            <el-switch v-model="parameters.status" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
    <!--编辑系统列表-->
    <el-dialog title="" :visible.sync="dialogFormVisibleup">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 20px">编辑参数定义</span>
        <span>
          <el-button @click="addlist(updateParameters)" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="abolish()" size="small">取消</el-button>
        </span>
      </div>
      <el-row style="height: auto">
        <el-form :model="parameters" label-width="120px">
          <el-form-item label="参数">
            <el-input v-model="parameters.parameter_id" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="parameters.parameter_name"></el-input>
          </el-form-item>

          <el-form-item label="参数类型">
            <el-select v-model="parameters.input_type" @change="inputTypeChenge" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最大值" v-if="parameters.input_type == 'NUMBER'">
            <el-input v-model="parameters.maxValue" type="number"></el-input>
          </el-form-item>
          <el-form-item label="最小值" v-if="parameters.input_type == 'NUMBER'">
            <el-input v-model="parameters.minValue" type="number"></el-input>
          </el-form-item>
          <el-form-item label="最大值" v-if="parameters.input_type == 'DATE'">
            <el-date-picker style="width: 100%" v-model="parameters.maxValue" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="最小值" v-if="parameters.input_type == 'DATE'">
            <el-date-picker style="width: 100%" v-model="parameters.minValue" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </el-form-item>
          <el-form-item label="有效">
            <el-switch v-model="parameters.status" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
          </el-form-item>
        </el-form>
      </el-row>
    </el-dialog>
    <!--编辑参数值-->
    <el-dialog title="" :visible.sync="dialogFormVisibleValue">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
        <span style="color: #3998F7;font-size: 22px">设定参数值</span>
        <span>
          <el-button type="primary" size="mini" @click="addVerify(upDateDictionary)" :disabled="!updataActive" v-if="dec">保存</el-button>
          <el-button type="danger" size="mini" @click="deleteOpen" :disabled="!updataActive" v-if="dec">取消</el-button>
        </span>
      </div>
      <el-form ref="form" :model="tableData" label-width="80px" v-if="dec" class="form" hide-required-asterisk>
        <el-form-item label="参数">
          <el-input v-model="tableData.parameter_id" :disabled="true" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="tableData.parameter_name" :disabled="true" style="width: calc(100% - 20px)"></el-input>
        </el-form-item>

        <el-form-item label="值" v-if="aaa()" class="home_star" prop="parameter_value" :rules="[{ required: true, message: '值不能为空' }]">
          <el-input v-model="tableData.parameter_value" :type="inputType" style="width: calc(100% - 20px)"></el-input>
          <p style="margin: 0;line-height: 20px;color: #CDCFD0" v-if="inputType == 'number'">{{ defData.min_value }}&nbsp;~&nbsp;{{ defData.max_value }}</p>
        </el-form-item>

        <el-form-item label="值" v-if="myonOff == 'TRUE-FALSE'">
          <el-switch v-model="tableData.parameter_value" active-color="#13ce66"> </el-switch>
        </el-form-item>

        <el-form-item label="值" v-if="myonOff == 'DATE'">
          <el-date-picker v-model="tableData.parameter_value" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%;"> </el-date-picker>
          <p style="margin: 0;line-height: 20px;color: #CDCFD0">{{ defData.min_value }}&nbsp;~&nbsp;{{ defData.max_value }}</p>
        </el-form-item>

        <el-form-item label="值" v-if="myonOff == 'LIST'">
          <el-select v-model="tableData.parameter_value" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in options" :key="item.category" :label="item.name" :value="item.category"> </el-option>
          </el-select>
        </el-form-item>
        <!-- html -->
        <el-form-item label="值" v-if="myonOff == 'HTML'">
          <quill-editor v-model="tableData.parameter_value"></quill-editor>
        </el-form-item>
        <!-- MINE -->
        <el-form-item label="值" v-if="myonOff == 'JSON'">
          <vue-json-editor v-model="tableData.parameter_value" :auto-format="true" :showBtns="false" :mode="'code'" lang="zh"> </vue-json-editor>
          <!-- <b-code-editor v-model="tableData.parameter_value" 
                    :auto-format="true" 
                    :smart-indent="true" 
                    theme="dracula" 
                    :indent-unit="4" 
                    :line-wrap="true" 
                    ref="editor"></b-code-editor> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import vueJsonEditor from "vue-json-editor";
import http from "../../../APIService/http";
import { MessageBox, Message } from "element-ui";
let number = 1;
export default {
  components: { vueJsonEditor, quillEditor },
  name: "Main",
  data() {
    return {
      paramter_value: "",
      onOff: true,
      left: "left",
      dialogFormVisibleValue: false,
      addUserDis: true,
      parameters: {
        parameter_name: "",
        parameter_id: "",
        input_type: "",
        maxValue: "",
        minValue: "",
        status: true,
      },
      options: [],
      input_type: "",
      options2: [
        {
          value: "TEXT",
          label: "文本",
        },
        {
          value: "NUMBER",
          label: "数值",
        },
        {
          value: "COMMENTS",
          label: "段落",
        },
        {
          value: "TRUE-FALSE",
          label: "开关",
        },
        {
          value: "LIST",
          label: "下拉列表",
        },
        {
          value: "JSON",
          label: "JsonCode",
        },
        {
          value: "DATE",
          label: "时间",
        },
      ],
      myonOff: "",
      inputType: "",
      parameter_id: "",
      defData: {},
      updataActive: "",
      dialogFormVisible3: false,
      dialogFormVisible: false,
      dialogFormVisibleup: false,
      treeKey: "",
      dec: false,
      schTitle1: "",
      //表格数据
      tableData: {
        parameter_name: "",
        parameter_id: "",
        parameter_value: "",
        parameter_value_s: "",
      },
      filterText: "",

      data: [],
      defaultProps: {
        label: "label",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getLibrary();
  },

  methods: {
    dakaiTanKuang() {
      this.dialogFormVisibleValue = true;
      if (this.myonOff == "TRUE-FALSE") {
        this.tableData.parameter_value_s = this.tableData.parameter_value ? true : false;
      }
      console.log(this.tableData.parameter_value_s);
    },
    aaa() {
      if (this.myonOff == "NUMBER") {
        return true;
      } else if (this.myonOff == "COMMENTS") {
        return true;
      } else if (this.myonOff == "TEXT") {
        return true;
      } else {
        return false;
      }
    },
    //删除列表
    deleteOpen() {
      // MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //     this.deleteDictionary()
      // }).catch(() => {
      //     Message({
      //         type: 'info',
      //         message: '已取消删除'
      //     });
      // });
      this.dialogFormVisibleValue = false;
      this.tableData.parameter_value = this.paramter_value;

      if (this.myonOff == "TRUE-FALSE") {
        this.tableData.parameter_value = this.tableData.parameter_value_s ? true : false;
      } else {
        this.tableData.parameter_value = this.paramter_value;
      }
    },
    async deleteDictionary() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {};
        data = { parameter_id: this.defData.parameter_id, tenant_id: user.tenant_id, user_id: user.user_id };

        await http.post("/wapi/parameters/deleteParameters", data).then((res) => {
          loading.close();
          if (res.success) {
            this.getDictionaryList(this.defData);
            this.getLibrary();
            Message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            Message.error("删除失败");
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },

    //编辑列表
    async upDateDictionary() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {};
        let parameter_id = this.parameter_id;

        let parameter_value = this.tableData.parameter_value;
        if (!(this.myonOff == "NUMBER")) {
          if (parameter_value == false) {
            parameter_value = "F";
          } else if (parameter_value == true) {
            parameter_value = "T";
          }
        }

        if (this.myonOff == "JSON") {
          parameter_value = parameter_value ? JSON.stringify(parameter_value) : "";
        }
        data = { parameter_value: parameter_value, parameter_id: parameter_id, tenant_id: user.tenant_id, user_id: user.user_id };

        await http.post("/wapi/parameters/updateParameters", data).then((res) => {
          loading.close();
          if (res.success) {
            this.getDictionaryList(this.defData);
            Message({
              type: "success",
              message: "保存成功",
            });
            this.dialogFormVisibleValue = false;
          } else {
            Message.error("保存失败");
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },
    addlist(callback) {
      if (!this.parameters.parameter_name) {
        Message({
          type: "error",
          message: "名称不能为空",
        });
      } else if (!this.parameters.parameter_id) {
        Message({
          type: "error",
          message: "参数不能为空",
        });
      } else if (!this.parameters.input_type) {
        Message({
          type: "error",
          message: "参数类型不能为空",
        });
      } else {
        if (this.parameters.input_type == "NUMBER" || this.parameters.input_type == "DATE") {
          if (!this.parameters.maxValue) {
            Message({
              type: "error",
              message: "最大值不能为空",
            });
          } else if (!this.parameters.minValue) {
            Message({
              type: "error",
              message: "最小值不能为空",
            });
          } else {
            if (this.parameters.input_type == "NUMBER") {
              if (parseInt(this.parameters.maxValue) <= parseInt(this.parameters.minValue)) {
                Message({
                  type: "error",
                  message: "最大值不能小于等于最小值",
                });
              } else {
                callback();
              }
            } else {
              if (this.parameters.maxValue <= this.parameters.minValue) {
                Message({
                  type: "error",
                  message: "最大值不能小于等于最小值",
                });
              } else {
                callback();
              }
            }
          }
        } else {
          callback();
        }
      }
    },
    //新增系统参数配置
    async addParameters() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {};
        data = { ...this.parameters, tenant_id: user.tenant_id, user_id: user.user_id };

        data.status = data.status ? "ACTIVE" : "INACTIVE";
        await http.post("/wapi/parameters/addParametersDef", data).then((res) => {
          loading.close();
          if (res.success) {
            this.dialogFormVisible = false;
            for (let key in this.parameters) {
              this.parameters[key] = "";
            }
            this.parameters.status = true;

            this.getLibrary();
            Message({
              type: "success",
              message: "保存成功",
            });
          } else {
            Message({
              type: "error",
              message: res.message || "保存失败",
            });
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },
    //编辑input类型
    inputTypeChenge(value) {
      if (value !== this.defData.input_type) {
        this.parameters.maxValue = "";
        this.parameters.minValue = "";
      } else {
        this.parameters.maxValue = this.defData.max_value;
        this.parameters.minValue = this.defData.min_value;
      }
    },

    //编辑系统参数配置
    async updateParameters() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {};
        data = { ...this.parameters, define_id: this.defData.define_id, tenant_id: user.tenant_id, user_id: user.user_id };

        let onoff = data.status;
        data.status = data.status ? "ACTIVE" : "INACTIVE";
        await http.post("/wapi/parameters/updateParametersDef", data).then((res) => {
          loading.close();
          if (res.success) {
            this.getLibrary();
            this.dialogFormVisibleup = false;
            for (let key in this.parameters) {
              this.parameters[key] = "";
            }
            this.parameters.status = true;
            this.onOff = onoff;
            this.defData = res.data[0];
            this.schTitle1 = res.data[0].parameter_name;
            this.tableData.parameter_name = res.data[0].parameter_name;
            this.tableData.parameter_id = res.data[0].parameter_id;
            if (res.upResult.length > 0) {
              debugger;
              this.tableData.parameter_value = res.upResult[0].parameter_value;
            }

            this.myonOff = res.data[0].input_type;

            if (res.data[0].input_type === "NUMBER") {
              this.inputType = "number";
            } else if (res.data[0].input_type === "TEXT") {
              this.inputType = "text";
            } else if (res.data[0].input_type === "COMMENTS") {
              this.inputType = "textarea";
            } else if (res.data[0].input_type === "JSON") {
              this.inputType = "json";
            } else if (res.data[0].input_type === "HTML") {
              this.inputType = "html";
            }

            Message({
              type: "success",
              message: "保存成功",
            });
          } else {
            Message({
              type: "error",
              message: res.message || "保存失败",
            });
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },

    addVerify(callback) {
      if (this.defData.input_type == "DATE" || this.defData.input_type == "NUMBER") {
        let parameter_value = "";
        let min_value = "";
        let max_value = "";

        if (this.defData.input_type == "JSON") {
          parameter_value = this.tableData.parameter_value ? JSON.stringify(this.tableData.parameter_value) : "";
        } else if (this.defData.input_type == "NUMBER") {
          parameter_value = parseInt(this.tableData.parameter_value);
          min_value = parseInt(this.defData.min_value);
          max_value = parseInt(this.defData.max_value);
        } else if (this.defData.input_type == "DATE") {
          parameter_value = this.tableData.parameter_value;
          max_value = this.defData.max_value;
          min_value = this.defData.min_value;
        }
        if (min_value <= parameter_value && parameter_value <= max_value) {
          callback();
        } else {
          this.tableData.parameter_value = this.paramter_value;
          if (this.defData.input_type == "NUMBER") {
            Message({
              type: "error",
              message: "值在" + this.defData.min_value + " ~ " + this.defData.max_value + "之间",
            });
          } else if (this.defData.input_type == "DATE") {
            Message({
              type: "error",
              message: "值在" + this.defData.max_value + " ~ " + this.defData.min_value + "之间",
            });
          }
        }
      } else {
        this.$refs["form"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            callback();
          }
        });
      }
    },
    //新增列表
    async addDictionary() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {};
        let parameter_value = "";
        if (this.myonOff == "JSON") {
          parameter_value = this.tableData.parameter_value ? JSON.stringify(this.tableData.parameter_value) : "";
        }
        data = {
          parameter_id: this.defData.parameter_id,
          parameter_name: this.defData.parameter_name,
          parameter_value: parameter_value,
          tenant_id: user.tenant_id,
          user_id: user.user_id,
        };

        await http.post("/wapi/parameters/addParameters", data).then((res) => {
          loading.close();
          if (res.success) {
            this.dialogFormVisible3 = false;

            this.getDictionaryList(this.defData);
            Message({
              type: "success",
              message: "保存成功",
            });
          } else {
            Message({
              type: "error",
              message: res.message || "保存失败",
            });
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },
    //获取列表
    async getDictionaryList(treeData) {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          parameter_id: treeData.parameter_id,
          tenant_id: user.tenant_id,
        };
        number = 1;
        this.tableData = {};

        await http.post("/wapi/parameters/getParametersListByParameterId", data).then((res) => {
          loading.close();
          if (res.success) {
            if (res.data[0]) {
              this.paramter_value = res.data[0].parameter_value;
              this.tableData = res.data[0];
              if (res.data[0].tenant_id == "retaium") {
                this.updataActive = true;
              }
              this.dec = true;
              if (this.myonOff == "TRUE-FALSE") {
                this.tableData.parameter_value = res.data[0].parameter_value == "T" ? true : false;
                //                                    this.tableData.parameter_value_s =  this.tableData.parameter_value?true:false
              }
              if (treeData.input_type == "JSON") {
                this.tableData.parameter_value = res.data[0].parameter_value ? JSON.parse(res.data[0].parameter_value) : {};
                this.tableData.parameter_value_s = res.data[0].parameter_value ? JSON.stringify(JSON.parse(res.data[0].parameter_value)) : "";
              }
            }
            if (res.data.length === 0) {
              this.dec = false;
            }
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },

    //获取选项
    async getDictionary_definitionList() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
        };
        this.options = [];

        await http.post("/wapi/parameters/getDictionaryDefinitionList", data).then((res) => {
          loading.close();
          if (res.success) {
            this.options = res.data;
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },
    //获取目录
    async getLibrary() {
      const loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
        };
        this.data = [
          { define_id: 1000, label: "系统内置", children: [] },
          { label: "自定义", children: [], define_id: 2000 },
        ];
        await http.post("/wapi/parameters/getParametersDefinitionList", data).then((res) => {
          loading.close();
          // this.$nextTick(() => { this.$refs.tree.setCurrentKey(this.treeKey)})
          setTimeout(() => {
            this.$refs.tree.setCurrentKey(this.treeKey);
          }, 100);
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].builtin === "T") {
                this.data[0].children.push(res.data[i]);
              } else {
                this.data[1].children.push(res.data[i]);
              }
            }
            if (this.data[1].children.length == 0) {
              this.data.splice(1, 1);
            }
          }
        });
      } catch (err) {
        loading.close();
        console.log(`error:${err}`);
      }
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    //新建系统参数弹框
    open3() {
      this.dialogFormVisible = true;
    },
    upOpen() {
      this.parameters.parameter_name = this.defData.parameter_name;
      this.parameters.parameter_id = this.defData.parameter_id;
      this.parameters.input_type = this.defData.input_type;
      this.parameters.maxValue = this.defData.max_value;
      this.parameters.minValue = this.defData.min_value;
      if (this.defData.input_type == "NUMBER") {
        this.parameters.maxValue = parseInt(this.defData.max_value);
        this.parameters.minValue = parseInt(this.defData.min_value);
      }
      if (this.defData.status === "ACTIVE") {
        this.parameters.status = true;
      } else {
        this.parameters.status = false;
      }

      this.dialogFormVisibleup = true;
    },
    abolish2() {
      this.dialogFormVisible3 = false;
      for (let key in this.tableData) {
        this.tableData[key] = "";
      }
    },
    abolish() {
      this.dialogFormVisible = false;
      this.dialogFormVisibleup = false;
      for (let key in this.parameters) {
        this.parameters[key] = "";
      }
    },

    handleNodeClick(data, node, ele) {
      if (data.label === "系统内置" || data.label === "自定义") {
        this.addUserDis = true;
        return;
      } else {
        this.addUserDis = false;

        this.schTitle1 = data.parameter_name;
        this.parameter_id = data.parameter_id;
        this.updataActive = true;
        this.defData = data;
        if (data.status === "ACTIVE") {
          this.onOff = true;
        } else {
          this.onOff = false;
        }

        this.getDictionaryList(data);
        if (data.input_type == "LIST") {
          this.getDictionary_definitionList();
        }
        //禁用状态
        this.updataActive = true;

        this.myonOff = data.input_type;

        if (data.input_type === "NUMBER") {
          this.inputType = "number";
        } else if (data.input_type === "TEXT") {
          this.inputType = "text";
        } else if (data.input_type === "COMMENTS") {
          this.inputType = "textarea";
        } else if (data.input_type === "HTML") {
          this.inputType = "html";
        } else if (data.input_type === "JSON") {
          this.inputType = "json";
        }
      }
    },
  },
};
</script>

<style>
#parameter {
  overflow: auto;
}
/*限制文字长度*/
#parameter .el-tree-node__content span {
  max-width: 240px;

  overflow: hidden;
  margin-left: 10px;
  color: #bbbbbb;
  text-overflow: ellipsis;
  font-size: 12px;
  white-space: nowrap;
}
#parameter .el-tree-node__expand-icon {
  display: none;
}
#parameter .el-tree-node__content {
  /*display: flex;*/
  /*justify-content: space-between;*/
  height: 40px;
}
#parameter .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content:before {
  content: "";
  display: inline-block;
  background: url("../../../assets/images/diction.png") no-repeat;
  background-size: 16px;
  width: 16px;
  height: 16px;
  margin: 20px;
}
#parameter .el-input__inner::-webkit-input-placeholder {
  text-align: center;
}
#parameter .el-tree-node.is-expanded.is-focusable > .el-tree-node__content {
  /*background: #f6f7fa;*/
}
#parameter .filter-tree .el-tree-node__children > .el-tree-node > .el-tree-node__content span {
  margin-left: 0;
  font-size: 16px;
  max-width: 240px;

  overflow: hidden;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*输入框背景*/
#parameter .sWei .el-input__inner {
  background: #eee;
}
#parameter .StoCen {
  background: white;
  height: auto;
  padding: 0 15px;
}
/*.el-main{
      padding: 0;
    }*/
#parameter {
  display: flex;
  justify-content: center;
  height: 100%;
}
#parameter .StoW .el-form-item__label {
  font-size: 14px;
  color: black;
  font-weight: bold;
}
#parameter .el-row {
  margin-bottom: 12px;
  height: 30px;
}
#parameter .xux {
  border-bottom: 2px dashed #eee;
  height: 10px;
}
#parameter .butC {
  padding: 8px 10px;
  margin-top: 26px;
}
#parameter .tally {
  border: 2px solid rgb(29, 170, 252);
  height: 100%;
  width: 110px;
  margin: 0 10px;
  padding: 0 5px;
  color: rgb(29, 170, 252);
}
#parameter .tally:nth-of-type(2) {
  border-color: rgb(30, 255, 79);
  color: rgb(30, 255, 79);
}
#parameter .tally:nth-of-type(3) {
  border-color: rgb(255, 203, 30);
  color: rgb(255, 203, 30);
}
#parameter .tally:nth-of-type(4) {
  border-color: rgb(255, 30, 244);
  color: rgb(255, 30, 244);
}
#parameter .tallyBox {
  height: 60px;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}
#parameter .tally .el-row {
  margin: 0;
  font-size: 12px;
  height: 25px;
}
#parameter .tally .el-row:nth-of-type(2) {
  text-align: center;
  font-size: 20px;
}
#parameter .cell {
  text-align: left;
}
#parameter .el-dialog__header {
  border-bottom: 2px dashed #dcdfe6;
  padding: 20px 0 20px 0;
  margin: 20px 20px 10px;
}
#parameter .el-dialog__close {
  display: none;
}
#parameter .el-dialog__body {
  /*padding-right:100px ;*/
}
#parameter .form .home_star label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 4px;
}
#parameter .el-form-item__label {
  color: black;
  font-size: 16px;
  padding-left: 20px;
  font-weight: bold;
  text-align: left;
}
.dialog-footer {
  margin-top: 10px;
}
#el-button span {
  font-weight: bold;
}
#el-form .el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/components/systemParameter.vue